import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('secondary'),
    children: [
        getRoute('/phone-verification', 'phoneVerification', 'phone-verification/phone_verification_page', { title: 'Accounts Phone Verification' }),
        getRoute('/new-user', 'accountNewUser', 'new-user/new_user_page', { title: 'Accounts New User' }),
        getRoute('/recovery-password', 'recoveryPassword', 'recovery-password/recovery_password_page', { title: 'Accounts Recovery Password' }),
        getRoute('/phone-verification/result', 'phoneVerification', 'phone-verification/phone_verification_result_page', { title: 'Phone Verification Result' }),
        getRoute('/account/exists', 'accounts', 'accounts/account_exists_page', { title: 'Account Already Exists' }),
        getRoute('/verify', 'accountsTwoFactorAuth', 'twofactorauth/verify_page', { title: 'Accounts Two Factor Authentication'}),
        getRoute('/verify-device', 'accountsVerifyDevice', 'verify-device/verify_device_page', { title: 'Accounts Verify Device'}),
        getRoute('/security-recommendations', 'securityRecommendations', 'security/security_recommendations_page', { title: 'Security Recommendations' }),
    ],
};